// Packages
import { useEffect, useState } from "react";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Styles
import "./schoolAdmin.css";
import "bootstrap/dist/css/bootstrap.css";
// Material Ui
import MaterialTable from "material-table";
import { getFromLocalStorage } from "../../utils/webStorage";
// Services
import PatchedPagination from "../../Common/PatchedPagination";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { useSelector } from "react-redux";

const BillingDetails = () => {
  const [assignedRights, setAssignedRights] = useState([]);
  const loginRole = getFromLocalStorage("loginRole");
  useEffect(() => {
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
  }, []);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const data = [
    {
      Sports: "Football",
      Invoice: 1,
      Pending: 0,
      Paid: 2,
      PastDue: 1,
      id: 1,
    },
  ];
  const columns = [
    {
      title: "id",
      field: "id",
      hidden: true,
    },
    {
      title: "SPORTS",
      field: "Sports",
      render: (row) => (
        <div className="d-flex">
          <div className="link-blue cp" key={row.id}>
            {row.Sports}
          </div>
        </div>
      ),
    },
    {
      title: "INVOICE",
      render: (row) => (
        <div>
          <label className="fs-18 medium">{row.Invoice}</label>
        </div>
      ),
    },
    {
      title: "PENDING",
      render: (row) => (
        <div>
          <label className="fs-18 medium">{row.Pending}</label>
        </div>
      ),
    },
    {
      title: "PAID",
      render: (row) => (
        <div>
          <label className="fs-18 medium">{row.Paid}</label>
        </div>
      ),
    },
    {
      title: "PAST DUE",
      render: (row) => (
        <div>
          <label className="fs-18 medium">{row.PastDue}</label>
        </div>
      ),
    },
  ];

  return (
    <div>
      {loginRole == "SCHOOL ADMIN" ||
      assignedRights.includes("View Invoices") ? (
        <div
          className={
            isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
          }
        >
          <SchoolAdminDashboard />
          <div className="mng-header stickyy">
            <h4 className="fs-24 bold mob-hd">Billing</h4>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 marIn-35">
            <MaterialTable
              components={{
                Pagination: PatchedPagination,
              }}
              style={{ width: "100%" }}
              title=""
              data={data}
              columns={columns}
              options={{
                filtering: false,
                selection: false,
                headerStyle: {
                  backgroundColor: "#F0F8FF",
                  fontFamily: "Rajdhani-Bold",
                  fontSize: 14,
                },
                rowStyle: {
                  fontSize: 17,
                  fontFamily: "Rajdhani-SemiBold",
                },
                pageSize: 10,
              }}
            ></MaterialTable>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </div>
  );
};

export default BillingDetails;
